import React from 'react';
import { AiOutlineMail, AiOutlinePhone } from 'react-icons/ai';
import {
  FaBehance,
  FaFacebookF,
  FaLinkedin,
  FaPaperPlane,
  FaStopwatch,
  FaTwitter,
  // eslint-disable-next-line prettier/prettier
  FaYoutube
} from 'react-icons/fa';
import { Link } from 'react-router-dom';

const MenuContent = () => (
  <div className="mobile-menu-bottom">
    <ul>
      <li className="bottom-item">
        <FaStopwatch className="icon" />
        Mon - Sat 8:30am to 7:30pm
      </li>
      <li className="bottom-item">
        <AiOutlineMail className="icon" />
        info@webmail.com
      </li>
      <li className="bottom-item">
        <AiOutlinePhone className="icon" />
        +987-098-098-09
      </li>
    </ul>
    <div className="bottom-btn text-center">
      <Link to="/contact" className="button button-primary">
        <FaPaperPlane className="icon" />
        Contact Us
      </Link>
    </div>
    <div className="social-icons">
      <a href="https://google.com">
        <FaFacebookF />
      </a>
      <a href="https://google.com">
        <FaTwitter />
      </a>
      <a href="https://google.com">
        <FaBehance />
      </a>
      <a href="https://google.com">
        <FaLinkedin />
      </a>
      <a href="https://google.com">
        <FaYoutube />
      </a>
    </div>
  </div>
);

export default MenuContent;
